import { mainApi } from "services/main";
import {
  GetApprovalStatRequest,
  GetApprovalStatResponse,
  ListTeamApprovalRequest,
  ListTeamApprovalResponse,
} from "./definitions";

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    listTeamApproval: builder.query<
      ListTeamApprovalResponse,
      ListTeamApprovalRequest
    >({
      query: ({ teamName, reviewTypes, ...rest }) => {
        const sp = new URLSearchParams();
        Object.entries(rest).forEach(([k, v]) => {
          if (v !== undefined && v !== null) sp.append(k, String(v));
        });
        if (reviewTypes && reviewTypes.length > 0) {
          reviewTypes.forEach((t) => sp.append("reviewTypes", t));
          if (reviewTypes.includes("KBDocumentReview")) {
            sp.append("reviewTypes", "KBDeletionReview");
          }
        }
        const qs = sp.toString();
        return {
          url: `team-approvals/${teamName}${qs ? `?${qs}` : ""}`,
        };
      },
      providesTags: ["Approvals"],
    }),
    getApprovalStat: builder.query<
      GetApprovalStatResponse,
      GetApprovalStatRequest
    >({
      query: (request: GetApprovalStatRequest) => ({
        url: `approvals/stats/${request.teamName}`,
        params: { searchType: request.searchType, user: request.user },
      }),
      providesTags: ["Approvals"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetApprovalStatQuery,
  useListTeamApprovalQuery,
  usePrefetch,
} = extendedApi;
